require('../../../modules/es.string.code-point-at');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').codePointAt;
